<template>
    <m-main-layout>
        <div class="page-content-main">
            21
        </div>
    </m-main-layout>
</template>

<script>
	export default {
		name: "dashboard"
	}
</script>

<style scoped>

</style>
